import React from 'react';
import ListViewSwitcher from './basic-switch';
import InvestorsViewSwitcher from './investors-switch';
import { SearchViewMode, isSearchListViewDefaultModeB } from './constants';
import { PillViewSwitcher } from 'components/list-view-switcher/pill-switch';
import { useABTests } from 'hooks/useABTests';

export interface SearchViewSwitcherProps {
  mode: SearchViewMode;
  setMode: (mode: SearchViewMode) => void;
  onClick?: (view: SearchViewMode) => void;
}

const SearchViewSwitcher: React.FC<SearchViewSwitcherProps & { investorsMode?: boolean; }> = ({ investorsMode, ...rest }) => {
  const abTests = useABTests();

  if (investorsMode) return <InvestorsViewSwitcher {...rest} />;
  if (isSearchListViewDefaultModeB(abTests)) return <PillViewSwitcher {...rest} />;

  return <ListViewSwitcher {...rest} />;
};

export default SearchViewSwitcher;
